import MuiDialogContent from '@mui/material/DialogContent';
import { ReactNode } from 'react';

const DialogContent = ({
    children,
    height,
}: {
    children: ReactNode;
    height?: string;
}) => {
    const dialogContentHeight = height ?? '50vh';

    return (
        <MuiDialogContent
            dividers
            sx={{ height: dialogContentHeight, overflow: 'auto' }}
        >
            {children}
        </MuiDialogContent>
    );
};

export default DialogContent;
